import * as fromErrors from './actions';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCommon from '../../../shared';
import { IShowErrors } from '../IShowErrors';
import { uniqBy } from '../../util/uniqby';
import { LoggingService } from '../../services/logging';

export interface State {
    errors: Array<fromCommon.IStatusMessage>;
    showErrors: IShowErrors;
}

export const initialState: State = {
    errors: [],
    showErrors: {
        open: false,
        MsgProcessID: 0,
        MsgEntityID: ''
    }
};
const log = new LoggingService();

export function reducer(
    state = initialState,
    action: fromErrors.ErrorsSidenavActionsUnion
): State {
    switch (action.type) {
        case fromErrors.ErrorsSidenavActionTypes.SetErrorsForProcess: {
            return {
                ...state,
                errors: [...state.errors, ...action.payload.errors].filter(
                    x =>
                        x.MsgProcessID === action.payload.processId ||
                        x.MsgProcessID === 0 ||
                        !x.MsgProcessID
                ),
                showErrors: {}
            };
        }
        case fromErrors.ErrorsSidenavActionTypes.ClearErrors:
            return {
                ...state,
                errors: [],
                showErrors: {}
            };
        case fromErrors.ErrorsSidenavActionTypes.SetShowErrors:
            return {
                ...state,
                showErrors: action.payload
            };
        case fromErrors.ErrorsSidenavActionTypes.RemoveErrors: {
            return {
                ...state,
                errors:
                    action.payload && action.payload.length > 0
                        ? [
                              ...state.errors.filter(x =>
                                  x.MsgEntityID
                                      ? !action.payload.includes(
                                            x.MsgEntityID.toString()
                                        )
                                      : true
                              )
                          ]
                        : []
            };
        }
        default:
            return state;
    }
}

const errorsState = createFeatureSelector<State>('errors');
export const getErrors = createSelector(errorsState, x => x.errors);
export const getShowErrors = createSelector(errorsState, x => x.showErrors);
export const selectErrorWithStatus = createSelector(
    getShowErrors,
    getErrors,
    (selected, errors) => {
        const result =
            errors.find(
                e =>
                    e.MsgEntityID === selected.MsgEntityID &&
                    e.MsgProcessID === selected.MsgProcessID
            ) ?? errors[0];
        log.verbose({
            type: 'errors-sidenav:reducer:selectErrorWithStatus',
            selected,
            errors,
            result
        });
        return result;
    }
);
// TODO: make a memoized selector to cache for each processid: https://blog.angularindepth.com/ngrx-parameterized-selector-e3f610529f8
